import React from 'react'
import Layout from './Layout'
import Media from 'react-media'
import RegisterMobile from './RegisterMobile'
import { SIZES } from 'src/styles/theme'
import RegisterDesktop from './RegisterDesktop'

export default function RegisterContainer() {
  return (
    <Layout>
      <Media query={`(max-width: ${SIZES.mobileBreakpoint})`}>{(matches) => (matches ? <RegisterMobile /> : <RegisterDesktop />)}</Media>
    </Layout>
  )
}
